import { useAuthStore } from 'src/store/auth';
import { RoleType } from 'src/constants';

interface MobileFooterProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const MobileFooter = ({ activeTab, setActiveTab }: MobileFooterProps) => {
  const { user } = useAuthStore();
  
  const menuItems = [
    {
      id: 'underwriting',
      label: 'Underwriting',
      icon: '/icons/validation-approval.svg',
      iconActive: '/icons/validation-approval-black.svg',
    },
    {
      id: 'id-cards',
      label: 'ID Cards',
      icon: '/icons/identification.svg',
      iconActive: '/icons/identification-black.svg',
    },
    {
      id: 'members',
      label: 'Members',
      icon: '/icons/user-list.svg',
      iconActive: '/icons/user-list-black.svg',
    }
  ];

  const menuAdminItems = [
    {
      id: 'groups',
      label: 'Groups',
      icon: '/icons/user-group.svg',
      iconActive: '/icons/user-group-black.svg',
    },
    {
      id: 'admins',
      label: 'Admins',
      icon: '/icons/user-list.svg',
      iconActive: '/icons/user-list-black.svg',
    }
  ];

  const allMenuItems = user?.role === RoleType.Admin 
    ? [...menuItems, ...menuAdminItems]
    : menuItems;

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-primary px-4 py-4 max-md:py-6">
      <div className="flex items-center justify-around">
        {allMenuItems.map(item => (
           <button
             key={item.id}
             onClick={() => setActiveTab(item.id)}
             className="flex flex-col items-center space-y-1 p-2 transition-colors focus:outline-none active:outline-none focus:ring-0 active:ring-0"
           >
             <img
               src={item.icon}
               alt={item.label}
               className={`w-6 h-6 ${activeTab === item.id ? 'opacity-100' : 'opacity-60'}`}
             />
            <span className="text-xs text-white font-medium max-md:hidden">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileFooter;